import { keyPressWrapper } from '../../../../bookings/util/useKeyboard';
import { useHomepageTiles } from '../../../../common/Experiments/HomepageTilesExperiment';
import { SpecialtyIcon, SpecialtyIconWrapper } from '../SearchSpecialtySelector.styles';
import { SpecialtyLabelSwitcher } from '../SpecialtyLabelSwitcher';
import {
  StyledOverflowSpecialtyButton,
  SpecialtyOverflowMenuChevDown,
  SpecialtyOverflowMenuIcon,
  SpecialtyOverflowMenuIconWrapper,
} from './SpecialtyOverflowMenu.styles';

export interface OverFlowSpecialtyButtonProps {
  onClick: () => void;
  active: boolean;
  label: string;
  altLabel?: string;
  icon?: string;
  open: boolean;
  isDesktop: boolean;
}

export const OverFlowSpecialtyButton = ({
  onClick,
  label,
  altLabel,
  active,
  open,
  icon,
  isDesktop,
}: OverFlowSpecialtyButtonProps) => {
  const homepageTilesExperiment = useHomepageTiles();

  return (
    <StyledOverflowSpecialtyButton
      onClick={onClick}
      onKeyPress={e => keyPressWrapper(e.key, onClick)}
      active={active}
      tabIndex={0}
      experiment={homepageTilesExperiment}
    >
      {icon && (isDesktop || !homepageTilesExperiment) ? (
        <SpecialtyIconWrapper experiment={homepageTilesExperiment}>
          <SpecialtyIcon
            src={icon}
            height={35}
            htmlAttributes={{ alt: label }}
            experiment={homepageTilesExperiment}
          />
        </SpecialtyIconWrapper>
      ) : (
        (isDesktop || !homepageTilesExperiment) && (
          <SpecialtyOverflowMenuIconWrapper>
            <SpecialtyOverflowMenuIcon />
          </SpecialtyOverflowMenuIconWrapper>
        )
      )}

      <SpecialtyLabelSwitcher desktopLabel={label} mobileLabel={altLabel} />
      <SpecialtyOverflowMenuChevDown $experiment={homepageTilesExperiment} open={open} />
    </StyledOverflowSpecialtyButton>
  );
};
